import ads from '@/i18n/pl/app/ads'
import analytics from '@/i18n/pl/app/analytics'
import chat from '@/i18n/pl/app/chat'
import downloads from '@/i18n/pl/app/downloads'
import gdpr from '@/i18n/pl/app/gdpr'
import hot17 from '@/i18n/pl/app/hot-17'
import player from '@/i18n/pl/app/player'
import posts from '@/i18n/pl/app/posts'
import nav from '@/i18n/pl/app/nav'
import priceList from '@/i18n/pl/app/price-list'
import search from '@/i18n/pl/app/search'
import sidebar from '@/i18n/pl/app/sidebar'
import voiceBank from '@/i18n/pl/app/voice-bank'

import notFound from '@/i18n/pl/app/404'

export default {
    '404': notFound,
    'ads': ads,
    'analytics': analytics,
    'chat': chat,
    'downloads': downloads,
    'gdpr': gdpr,
    'hot-17': hot17,
    'nav': nav,
    'posts': posts,
    'player': player,
    'price-list': priceList,
    'search': search,
    'sidebar': sidebar,
    'voice-bank': voiceBank
}
